import service from "@irati/utils/tracking/index";
var TRACKING_ROOT = "admin_onboarding_";
var TenantSetupTracking = /** @class */ (function () {
    function TenantSetupTracking() {
        this.viewStep = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "view_step", params);
        };
        this.navigateStep = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "navigate_step", params);
        };
        this.selectOption = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "select_option", params);
        };
        this.markStepComplete = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "mark_step_complete", params);
        };
        this.markStepSkipped = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "mark_step_skipped", params);
        };
        this.finishSetup = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "finish_setup", params);
        };
        this.viewSetupModal = function () {
            service.trackOnboardingEvent(TRACKING_ROOT + "view_setup_modal");
        };
        this.clickSetupModal = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "dismiss_setup_modal", params);
        };
        this.exitSetup = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "dismiss_setup_modal", params);
        };
        this.viewResetChangesModal = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "view_warning_modal", params);
        };
        this.resetChangesModalAction = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "dismiss_warning_modal", params);
        };
        this.openIntercom = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "open_intercom", params);
        };
        this.viewTenantSetupReminderTile = function (params) {
            service.trackOnboardingEvent(TRACKING_ROOT + "view_reminder_tile", params);
        };
    }
    return TenantSetupTracking;
}());
var tenantSetupTracking = new TenantSetupTracking();
export { default as TenantSetupInterfaces } from "./interfaces";
export { ClickedModalValues, ExitSetupButtonValues, ResetModalClickedValues, ReminderPlatformValues } from "./enums";
export default tenantSetupTracking;
